window.addEventListener('DOMContentLoaded', () => {
  // Scene, Camera, and Renderer Setup
  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(
    75,
    window.innerWidth / window.innerHeight,
    0.1,
    1000
  );
  camera.position.z = 6;

  const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setSize(window.innerWidth, window.innerHeight);
  renderer.domElement.style.position = "absolute";
  renderer.domElement.style.top = "0";
  renderer.domElement.style.left = "0";
  renderer.domElement.style.zIndex = "-1";

  // Attach canvas to the .slideshow container
  const heroSection = document.querySelector('.slideshow');
  if (heroSection) {
    heroSection.style.position = "relative";
    heroSection.style.width = "100%";
    heroSection.style.height = "100vh";
    heroSection.appendChild(renderer.domElement);
    console.log("🚀 Enhanced Chroma Fluid Loaded!");
  } else {
    document.body.appendChild(renderer.domElement);
    console.error("🚨 Container not found!");
  }

  // 🌊 **Enhanced Liquid Chrome Shader Material (More Waves)**
  const fluidMaterial = new THREE.ShaderMaterial({
    uniforms: {
      time: { value: 0 }
    },
    vertexShader: `
      uniform float time;
      varying vec2 vUv;
      void main(){
        vUv = uv;
        vec3 pos = position;
        // Enhanced fluid wave distortions
        pos.z += sin(vUv.y * 12.0 + time * 2.5) * 0.3;
        pos.x += cos(vUv.x * 12.0 + time * 2.5) * 0.3;
        pos.y += sin(vUv.x * 10.0 + time * 1.8) * 0.2;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(pos, 1.0);
      }
    `,
    fragmentShader: `
      uniform float time;
      varying vec2 vUv;
      void main(){
        // Stronger blending for an enhanced fluid feel
        vec3 color1 = vec3(0.96, 0.70, 0.84); // Pastel Pink
        vec3 color2 = vec3(0.74, 0.83, 0.98); // Pastel Blue
        vec3 color3 = vec3(0.50, 0.70, 1.00); // Soft Purple
        float wave = sin(time * 1.8 + vUv.y * 5.0) * 0.6 + 0.5;
        vec3 fluid = mix(color1, color2, wave);
        fluid = mix(fluid, color3, cos(time + vUv.x * 3.5) * 0.5 + 0.5);
        gl_FragColor = vec4(fluid, 1.0);
      }
    `,
    transparent: true
  });

  // **Create the Fluid Surface**
  const fluidGeometry = new THREE.PlaneGeometry(12, 7, 128, 128);
  const fluidMesh = new THREE.Mesh(fluidGeometry, fluidMaterial);
  scene.add(fluidMesh);

  // **Lighting for a Softer Glow**
  const ambientLight = new THREE.AmbientLight(0xffffff, 1.3);
  scene.add(ambientLight);
  const pointLight = new THREE.PointLight(0xff88ff, 18, 22);
  pointLight.position.set(2, 3, 4);
  scene.add(pointLight);

  // 🖱️ **Mouse Interaction for Subtle Fluid Movement**
  let mouseX = 0, mouseY = 0;
  window.addEventListener('mousemove', (e) => {
    mouseX = (e.clientX / window.innerWidth) * 2 - 1;
    mouseY = -(e.clientY / window.innerHeight) * 2 + 1;
  });

  // 🎞️ **Animation Loop**
  const clock = new THREE.Clock();
  function animate() {
    const elapsedTime = clock.getElapsedTime();
    fluidMaterial.uniforms.time.value = elapsedTime;

    // Apply enhanced interactive movement based on mouse
    fluidMesh.rotation.x = mouseY * 0.12;
    fluidMesh.rotation.y = mouseX * 0.12;

    renderer.render(scene, camera);
    requestAnimationFrame(animate);
  }
  animate();

  // 🔄 **Responsive Handling**
  window.addEventListener('resize', () => {
    renderer.setSize(window.innerWidth, window.innerHeight);
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
  });
});
